
import { defineComponent } from "vue";

export default defineComponent({
  methods: {
    closeModal() {
      this.$router.push("Login");
    },
  },
});
